import { jsxs as a, jsx as e } from "react/jsx-runtime";
import * as s from "react";
import { X as n } from "lucide-react";
import { cn as m } from "../../../lib/utils.js";
import { Badge as c } from "../badge/Badge.js";
const f = s.forwardRef(({ className: i, children: l, onClose: r, ...o }, t) => a(c, { ref: t, className: m("pr-1 pl-2 gap-1.5 w-fit", i), ...o, children: [e("span", { className: "inline-block", children: l }), r && e("button", { type: "button", onClick: r, className: "inline-flex h-3.5 w-3.5 items-center justify-center rounded-full hover:bg-text-primary/10 focus-visible:outline-none flex-shrink-0", children: e(n, { className: "h-3 w-3" }) })] }));
f.displayName = "ClosableBadge";
export {
  f as ClosableBadge
};
//# sourceMappingURL=ClosableBadge.js.map
